export default __webpack_public_path__ + "static/media/icon-woori@3x.94136cf0.png";